export const useBTBreakpoints = () => {
  const viewport = useViewport()
  const breakpoint = viewport.breakpoint

  const isMobile = computed(() => breakpoint.value && viewport.isLessThan('sm'))
  const isTablet = computed(() => breakpoint.value && viewport.isGreaterOrEquals('sm') && viewport.isLessThan('md'))
  const isDesktopSmall = computed(
    () => breakpoint.value && viewport.isGreaterOrEquals('md') && viewport.isLessThan('xl')
  )
  const isDesktopLarge = computed(() => breakpoint.value && viewport.isGreaterOrEquals('xl'))
  const isDesktop = computed(() => isDesktopSmall.value || isDesktopLarge.value)

  return { isMobile, isTablet, isDesktop, isDesktopSmall, isDesktopLarge }
}
